import { SpaceUse } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.SpaceUse */
export { SpaceUse };
import { CreditRating } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.CreditRating */
export { CreditRating };
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.DealRole */
export var DealRole;
(function (DealRole) {
    DealRole[DealRole["None"] = 0] = "None";
    DealRole[DealRole["Buyer"] = 1] = "Buyer";
    DealRole[DealRole["Seller"] = 2] = "Seller";
})(DealRole || (DealRole = {}));
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.StarRating */
export var StarRating;
(function (StarRating) {
    StarRating[StarRating["None"] = 0] = "None";
    StarRating[StarRating["OneStar"] = 1] = "OneStar";
    StarRating[StarRating["TwoStar"] = 2] = "TwoStar";
    StarRating[StarRating["ThreeStar"] = 3] = "ThreeStar";
    StarRating[StarRating["FourStar"] = 4] = "FourStar";
    StarRating[StarRating["FiveStar"] = 5] = "FiveStar";
})(StarRating || (StarRating = {}));
import { PropertyType } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.PropertyType */
export { PropertyType };
import { LocationType } from "../../../../CoStar/Api/SuiteResults/Types/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.LocationType */
export { LocationType };
import { ContiguousSpaceType } from "../../../../CoStar/Api/Search/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.ContiguousSpaceType */
export { ContiguousSpaceType };
import { ServiceType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.ServiceType */
export { ServiceType };
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.SpaceType */
export var SpaceType;
(function (SpaceType) {
    SpaceType[SpaceType["None"] = 0] = "None";
    SpaceType[SpaceType["Relet"] = 1] = "Relet";
    SpaceType[SpaceType["New"] = 2] = "New";
    SpaceType[SpaceType["Sublet"] = 3] = "Sublet";
    SpaceType[SpaceType["Assignment"] = 4] = "Assignment";
    SpaceType[SpaceType["CoWorking"] = 9] = "CoWorking";
})(SpaceType || (SpaceType = {}));
import { FundStatus } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.FundStatus */
export { FundStatus };
import { FundStrategy } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.FundStrategy */
export { FundStrategy };
import { FundStructure } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.FundStructure */
export { FundStructure };
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.Caller */
export var Caller;
(function (Caller) {
    Caller[Caller["None"] = 0] = "None";
    Caller[Caller["ProfessionalDirectory"] = 1] = "ProfessionalDirectory";
})(Caller || (Caller = {}));
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.ParkingTypeCategory */
export var ParkingTypeCategory;
(function (ParkingTypeCategory) {
    ParkingTypeCategory[ParkingTypeCategory["None"] = 0] = "None";
    ParkingTypeCategory[ParkingTypeCategory["Surface"] = 1] = "Surface";
    ParkingTypeCategory[ParkingTypeCategory["Covered"] = 2] = "Covered";
    ParkingTypeCategory[ParkingTypeCategory["Reserved"] = 3] = "Reserved";
})(ParkingTypeCategory || (ParkingTypeCategory = {}));
import { BuildingClass } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.BuildingClass */
export { BuildingClass };
import { ConstructionStatus } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.ConstructionStatus */
export { ConstructionStatus };
import { LandType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.LandType */
export { LandType };
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.Tenancy */
export var Tenancy;
(function (Tenancy) {
    Tenancy[Tenancy["Single"] = 1] = "Single";
    Tenancy[Tenancy["Multiple"] = 2] = "Multiple";
})(Tenancy || (Tenancy = {}));
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.BuildOutStatusType */
export var BuildOutStatusType;
(function (BuildOutStatusType) {
    BuildOutStatusType[BuildOutStatusType["RawSpace"] = 1] = "RawSpace";
    BuildOutStatusType[BuildOutStatusType["ShellSpace"] = 2] = "ShellSpace";
    BuildOutStatusType[BuildOutStatusType["PartialBuildOut"] = 3] = "PartialBuildOut";
    BuildOutStatusType[BuildOutStatusType["FullBuildOut"] = 4] = "FullBuildOut";
    BuildOutStatusType[BuildOutStatusType["SpecSuite"] = 5] = "SpecSuite";
})(BuildOutStatusType || (BuildOutStatusType = {}));
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.ListingContiguousSpaceType */
export var ListingContiguousSpaceType;
(function (ListingContiguousSpaceType) {
    ListingContiguousSpaceType[ListingContiguousSpaceType["None"] = 0] = "None";
    ListingContiguousSpaceType[ListingContiguousSpaceType["ContiguousInBuilding"] = 1] = "ContiguousInBuilding";
    ListingContiguousSpaceType[ListingContiguousSpaceType["InOneSuite"] = 2] = "InOneSuite";
    ListingContiguousSpaceType[ListingContiguousSpaceType["TotalInBuilding"] = 3] = "TotalInBuilding";
    ListingContiguousSpaceType[ListingContiguousSpaceType["TotalInListing"] = 4] = "TotalInListing";
})(ListingContiguousSpaceType || (ListingContiguousSpaceType = {}));
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.SpacePosition */
export var SpacePosition;
(function (SpacePosition) {
    SpacePosition[SpacePosition["None"] = 0] = "None";
    SpacePosition[SpacePosition["FoodCourt"] = 1] = "FoodCourt";
    SpacePosition[SpacePosition["Inline"] = 2] = "Inline";
    SpacePosition[SpacePosition["EndCap"] = 3] = "EndCap";
    SpacePosition[SpacePosition["Outparcel"] = 4] = "Outparcel";
    SpacePosition[SpacePosition["Corner"] = 5] = "Corner";
})(SpacePosition || (SpacePosition = {}));
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.AddressExposureType */
export var AddressExposureType;
(function (AddressExposureType) {
    AddressExposureType[AddressExposureType["None"] = 0] = "None";
    AddressExposureType[AddressExposureType["Normal"] = 1] = "Normal";
    AddressExposureType[AddressExposureType["SuppressedAddress"] = 2] = "SuppressedAddress";
    AddressExposureType[AddressExposureType["Disconnected"] = 3] = "Disconnected";
})(AddressExposureType || (AddressExposureType = {}));
import { AssetType } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.AssetType */
export { AssetType };
import { Region } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.Region */
export { Region };
import { InvestmentType } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.InvestmentType */
export { InvestmentType };
import { SaleCondition } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.SaleCondition */
export { SaleCondition };
import { SaleStatus } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.SaleStatus */
export { SaleStatus };
/** CoStar.Api.SuiteSearchAdapter.EnumTypes.SaleType */
export var SaleType;
(function (SaleType) {
    SaleType[SaleType["None"] = 0] = "None";
    SaleType[SaleType["Investment"] = 1] = "Investment";
    SaleType[SaleType["OwnerUser"] = 2] = "OwnerUser";
})(SaleType || (SaleType = {}));
